export default "__VITE_ASSET__Cf97AExa__"